import type { FC } from "react";
import { TEXT } from "@/constants/text";
import styles from "@/layouts/AuthLayout/AuthPromoPanel.module.css";
import InfillionLogo from "@/components/InfillionLogo";

const AuthPromoPanel: FC = () => (
  <div className={styles.panel}>
    <div aria-hidden="true" className={styles.circle} />
    <div className={styles.header}>
      <InfillionLogo
        aria-label={TEXT.auth.promo.wordmark}
        className={styles.logo}
        role="img"
      />
    </div>
    <div className={styles.body}>
      <h1 className={styles.headline}>
        <span className={styles.headlineLight}>
          {TEXT.auth.promo.headlineLight}
        </span>
        <span className={styles.headlineBold}>
          {TEXT.auth.promo.headlineBold}
        </span>
      </h1>
      <p className={styles.badge}>{TEXT.auth.promo.badgeLabel}</p>
      <p className={styles.subtitle}>{TEXT.auth.promo.subtitle}</p>
    </div>
    <div className={styles.footer}>{TEXT.auth.promo.copyright}</div>
  </div>
);

export default AuthPromoPanel;
